<script setup>
defineProps({
  fieldModel: Object
})
</script>

<template>
  <div class="invalid-feedback d-block">
    <div
      v-for="(errorMessage, index) in fieldModel.errors"
      :key="index"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>
